<template>
<div >

   <label style="font-size:40px;"> Requisiciones Finalizados </label>
      <div v-if="requisiciones == 'no hay datos' ">
        No hay Requisiciones en Proceso
      </div>
      <div v-else>
        <article class="message is-danger" v-for="reque in requisiciones">
          <div class="message-body">
            <div class="columns">
              <div class="column is-4">
                #{{reque.id}} <span v-html="parseDate(reque.fecha )"></span> <br>
                Gerente de : <b> {{reque.gerente}}  </b> <br>
                Solicita puesto : <b> {{ reque.puesto_requerido }} <b> X {{ reque.vacantes }} </b>  </b> <br>
                Salario : <b>$0.00 - $2500.00</b>
              </div>

              <div class="column is-8" >

                <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" :id=" 'tableta' + reque.id " v-html="pintarContenidoTable(reque)">

                </table>

              </div>
            </div>

          </div>
        </article>

      </div>

</div>
</template>

<script>

import axios from 'axios'
import Cors from 'cors'
import moment from 'moment'
import { SnotifyPosition, SnotifyStyle } from 'vue-snotify'

const { AbilityBuilder } = require('casl')

export default {
  data () {
    return {
      menuComponente: 'app-create',
      mail: '',
      pass: '',
      requisiciones: [],
      puestos: [],
      empresas: [],
      reqHumanos: [],
      idpuesto: '',
      requisitos: '',
      iddepartamento: '',
      namepuesto: '',
      idgerente: '',
      fechahoy: '',
      controlSolicitar: 0,
      selectedPuesto: '', /// aqui empieza los datos del usuario
      uName: '',
      uApellido: '',
      uApellidoM: '',
      uMail: '',
      uPhone: '',
      uCivil: '',
      uCurp: '',
      uRfc: '',
      uGenero: '',
      uFNacimiento: '',
      uNacimiento: '',
      uDireccion: '',
      uPuesto: '',
      uRequisicionId: '',
      candidatos: [],
      mostrarLista: 0,
      currentCandidato: '',
      uPuestoid: '',
      salarios: [],
      detallesRequ: []

    }
  },
  created () {
    22

    this.getRequisiciones()
  },
  methods: {
    parseDate:function(data){
      return moment(data,'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    pintarContenidoTable: function (reque) {
      var estancia = this

      console.log('hola a todos')

      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: '*',
        table: 'recursos_humanos',
        where: `requisicion_id = '${reque.id}' `,
        condition: ''
      })
        .then(function (response) {
          if (response.status == 200) {
            console.log('llega de obtener los reh')
            console.log(response.data)

            var tableCandidates = ''

            console.log(' va a entrar al for')
            for (var key in response.data) {
              if (response.data[key].status_laboral_id == 7) {
                var estadoPoner = "<label style='color:red;' > Rechazado </label>  "
              } else if (response.data[key].status_laboral_id == 5) {
                var estadoPoner = "<label style='color:green;' > Seleccionado </label>  "
              } else {
                var estadoPoner = "<label style='color:grey;' > Postulado </label>  "
              }

              tableCandidates += `<tr>
                            <td>
                              <figure class="image is-64x64">
                                <img class="is-rounded" src="https://bulma.io/images/placeholders/64x64.png">
                              </figure>
                            </td>
                            <td>
                              <b>
                                ${response.data[key].nombre}
                                ${response.data[key].apellido_paterno}
                                ${response.data[key].apellido_materno}
                              </b>

                            </td>
                            <td>
                                ${response.data[key].mail} <br> +52 ${response.data[key].telefono} <br> ${response.data[key].estado_civil}
                            </td>
                            <td>
                              CURP :  ${response.data[key].curp} <br> R F C : ${response.data[key].rfc}
                            </td>

                            <td>
                              ${estadoPoner}
                            </td>


                          </tr>`

              //
              //
              //
              //   </td>
              //   <td v-if="candidato.status_laboral_id == 7 ">
              //     <label class="is-danger" style="color:red;"> Rechazado</label>
              //   </td>
              //   <td v-else-if="candidato.status_laboral_id == 5" >
              //     <label class="is-danger" style="color:green;"> Aceptado </label>
              //   </td>
              //   <td v-else-if="candidato.status_laboral_id == 3" >
              //
              //
              //
              //     <div class="tooltip">
              //       <a class="button is-primary is-outlined" > <font-awesome-icon icon="coffee" class="fa-lg" /> </a>
              //       <span class="tooltiptext">Entrevistado</span>
              //     </div>
              //
              //     <div class="tooltip">
              //       <a class="button is-primary is-outlined" @click="fRechazar(candidato)"> <font-awesome-icon icon="times" class="fa-lg" /> </a>
              //       <span class="tooltiptext">Rechazar</span>
              //     </div>
              //
              //     <div class="tooltip">
              //       <a  class="button is-primary is-outlined" @click="fSeleccionar(candidato)" > <font-awesome-icon icon="check" class="fa-lg" /> </a>
              //       <span class="tooltiptext">Seleccionar</span>
              //     </div>
              //
              //   </td>
              //   <td v-else >
              //
              //     <div class="tooltip">
              //       <a class="button is-primary is-outlined" @click="fCitar(candidato)" > <font-awesome-icon icon="calendar-alt" class="fa-lg" /> </a>
              //       <span class="tooltiptext">Citar</span>
              //     </div>
              //
              //     <div class="tooltip">
              //       <a class="button is-primary is-outlined" @click="fRechazar(candidato)"> <font-awesome-icon icon="times" class="fa-lg" /> </a>
              //       <span class="tooltiptext">Rechazar</span>
              //     </div>
              //
              //   </td>
              // </tr>
              //

              $('#tableta' + reque.id).html(tableCandidates)
            }
          } else {
            console.log('error')
          }
        })

      return `<tr>
                <td> Sin candidatos registrados
                </td>


              </tr>`
    },
    updateRecursosHumanos: function (requisicionid) {
      console.log('aqui entra en la funcion de actualizar updtaeRecursosHumanos')
      var table = 'requisicion'
      var set = 'status_requisicion_id = 3 '
      var where = `id = ${requisicionid} `
      axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=updateFromWhere&table=${table}&set=${set}&where=${where}`)
        .then(function (response) {
          if (response.status == 200) {
            estancia.mostrarLista = 1
            $('#modalSelectCandidatos').removeClass('is-active')
            console.log('SE ACTUALIZA LA REQUISICION ')
          } else {
            console.log('error')
          }
        })
    },
    updateFrom: function (id, table, number) { // aqui se actualiza, el estatus a 5 . RECHAZADO
      console.log('entra en la funcion updateFrom')
      var estancia = this
      var table = table
      var set = `status_laboral_id = ${number} `
      var where = `id = ${id}`

      axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=updateFromWhere&table=${table}&set=${set}&where=${where}`)
        .then(function (response) {
          console.log('respuesta ')
          console.log(response)

          if (response.status == 200) {
            estancia.mostrarLista = 1
            $('#modalSelectCandidatos').removeClass('is-active')
          } else {
            console.log('error')
          }
        })
    },
    SelectCandidato: function (reqId) {
      $('.bodyListCandidates').hide()
      // $(e.target).parent().parent().parent().next().show();

      var estancia = this
      var table = 'recursos_humanos'
      var where = `requisicion_id =${reqId} AND status_laboral_id = 1 `

      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: '*',
        table: 'recursos_humanos',
        where: 'requisicion_id = ' + reqId,
        condition: 'AND status_laboral_id = 1'
      })
        .then(function (response) {
          estancia.candidatos = response.data
        })
    },
    getRequisiciones: function () {
      var estancia = this
      var where = `status_requisicion_id = 1 ORDER BY fecha DESC `
      // axios.get(`/api/recursos_humanos_jean/rh-vue/conexion/assignFunction.php?action=getFromWhere&table=requisicion&where=${where}`)
      axios.post('https://86lv4sm87a.execute-api.us-west-1.amazonaws.com/deploy2/read', {
        select: '*',
        table: 'requisicion',
        where: 'status_requisicion_id = 3 ',
        condition: 'ORDER BY fecha DESC'
      })
        .then(function (response) {
          if (response.status == 200) {
            estancia.requisiciones = response.data
          } else {
            console.log('error')
          }
        })
    }

  }

}
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

  input[name="accordion-select"], .panel-block {
    display: none;
  }
  label.panel-heading {
    cursor: pointer;
    display: block;
  }

  /* the magic */
  #panel-1:checked ~ .panel > .body-1,
  #panel-2:checked ~ .panel > .body-2,
  #panel-3:checked ~ .panel > .body-3 {
    display: flex;
  }

  $modal-content-width: 900px !default
</style>
